module.exports = __webpack_public_path__ + "static/media/instagram_logo.5bb945a9.webp";